import { GetNotificationSegment, GetNotificationSegmentVariables } from './__generated__/GetNotificationSegment'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query GetNotificationSegment($id: String!) {
    notificationSegment: notificationSegmentV2(id: $id) {
      ... on NotificationSegmentV2 {
        id
        title
        isDynamic
        dynamicUrl
        subscriberIds
      }
    }
  }
`

export const useGetNotificationSegment = (id: string) => {
  return useQuery<GetNotificationSegment, GetNotificationSegmentVariables>(QUERY, {
    variables: {
      id
    }
  })
}
